define('app-console/config',['require','exports','module'],function(require,exports,module){
	var STRING="string";
		return function(){
			var conf=module.config(),
				config={};
			if(typeof conf==='object'){
				config=conf;
			}
			config.level=config.level || typeof conf===STRING && conf || conf.level||'none'
			return config;
		}
});
